import { memo } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { DeviceSimPanel } from "./DeviceSimPanel";

export const DeviceSimDialog = memo(function DeviceSimDialog({
  instance,
  onOpenChange,
}: {
  instance: { id: string; name: string } | null;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={!!instance} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-5xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>SIM cards · {instance?.name}</DialogTitle>
          <DialogDescription>
            Status and usage of the SIMs in this device.
          </DialogDescription>
        </DialogHeader>
        {instance && (
          <DeviceSimPanel instanceId={instance.id} deviceName={instance.name} />
        )}
      </DialogContent>
    </Dialog>
  );
});
